import { render, staticRenderFns } from "./noncustomer.vue?vue&type=template&id=5acb5ed8"
import script from "./noncustomer.vue?vue&type=script&lang=js"
export * from "./noncustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports